document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
      const optionSubsaveEl = document.querySelector('[data-option-subsave]');
      const optionOnetimeEl = document.querySelector('[data-option-onetime]');

      if (optionSubsaveEl && optionOnetimeEl) {
        const comparePrice = optionOnetimeEl.querySelector('[data-price-onetime]').textContent;
        const priceSubsaveEl = document.querySelector('[data-price-subsave]');
        
        if (comparePrice && !priceSubsaveEl.classList.contains('compare-price-added')) {
          const comparePriceEl = document.createElement('s');
          comparePriceEl.classList.add('compare-price-subsave');
          comparePriceEl.textContent = comparePrice;

          priceSubsaveEl.insertAdjacentElement('afterend', comparePriceEl);

          priceSubsaveEl.classList.add('compare-price-added');
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});